import React, { Component } from 'react';
import './index.css';

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {

    let containerStyles = {}
    if (this.props.container) {
      containerStyles = {
        height: "100px",
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center"
      }
    }

    return (
      <div style={containerStyles}>
        <div className="loading"
          style={{
            height: this.props.height,
            width: this.props.width,
            border: `2px solid ${this.props.fill}`,
            borderRadius: "50%"
          }}
        >
      </div>
    </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.js